import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameStatusList extends BaseModelAPI {

	static entity = 'stockopnamestatuslist'
	static entityName = 'stockopnamestatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
